import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GRAY, GRAY_DARK, GRAY_LIGHT, GRAY_LIGHTEST, RED, WHITE, BLACK } from '../../../theme/colors'

interface ImagePreviewProps {
  src: string
}

export const Container = styled.div`
  width: 75%;
  background-color: ${WHITE};
  display: inline-flex;
  flex-direction: column;
  padding: 0 240px;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`

export const StrongText = styled.div`
  color: ${GRAY_DARK};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  word-break: break-all;
  @media (max-width: 768px) {
    width: 50%;
  }
  @media (max-width: 320px) {
    width: fit-content;
  }
`

export const CardPreview = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 448px;
  border-radius: 5px;
  border: 1px solid #D7D1D2;
  padding: 4px;
  position: relative;
  cursor: pointer;
  @media (max-width: 768px) {
    flex-direction: row;
  }
  .imgThumbnail {
    max-height: 255px;
    object-fit: cover;
    width: 40%;
  }
  .imgPreview {
    max-height: 255px;
    width: 60%;
    object-fit: contain;
  }
`

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Text = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
  width: 100%;
  word-break: break-all;
  border: 1px solid ${GRAY};
  padding: 8px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: row;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const LockerGrid = styled.div`
  max-width: 446px;
  width: 100%;
  padding-bottom: 38px;
`

export const ProjectData = styled.div`
  display: flex;
  flex-flow: column;
`

export const DataRow = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
`

export const DataText = styled.div`
  font-size: 16px;
  max-width: 218px;
  width: 100%;
  @media (max-width: 768px) {
    max-width: 140px;
  }
`

export const DataValue = styled.div`
  color: ${GRAY_DARK};
  font-weight: 600;
  font-size: 16px;
  word-break: break-all;
  flex: 1;
`

export const EditButton = styled.div`
  color: ${RED};
  align-self: flex-end;
  cursor: pointer;
`

export const Notes = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const Ideas = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const Inspiration = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const Images = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  column-gap: 15px;
  row-gap: 10px;
  justify-items: flex-start;
  margin-top: 10px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  }
`

export const ImageContainer = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 768px) {
    width: 160px;
  }
`

export const Image = styled.div`
  background-size: cover;
  background-position: center;
  background-image: url('${({ src }: ImagePreviewProps) => src || ''}');
  width: 200px;
  height: 200px;
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
  background-color: ${GRAY_LIGHT};
`

export const DocIcon = styled(Icon)`
  width: 200px;
  height: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 32px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
`

export const LogoImage = styled.img`
  width: 200px;
  height: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 32px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  padding: 34%;
  @media (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
`

export const InspirationName = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 8px;
  font-size: 12px;
`

export const Color = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`
export const Files = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
`

export const ImageText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-top: 6px;
  overflow: hidden;
  white-space: nowrap;
`

export const Products = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  .thumbnail-image {
    height: auto;
  }
  @media (max-width: 698px) {
    section {
      width: 50%;
    }
  }
  @media (max-width: 320px) {
    .imgCont {
      height: unset;
    }
  }
`

export const ActionSection = styled.div`
  width: 85%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  margin-inline: auto;
  padding-top: 24px;
  border-top: 1px solid ${GRAY_LIGHT};
  @media (max-width: 698px) {
    display: none;
  }
`

export interface ActionButtonProps {
  $variant?: 'primary' | 'secondary'
}

export const ActionButton = styled.button<ActionButtonProps>`
  padding: ${({ $variant }) => ($variant === 'primary' ? '10px 48px' : '10px 32px')};
  font-size: 16px;
  font-weight: 400;
  border-radius: 9999px;
  cursor: pointer;
  border: ${({ $variant }) => ($variant === 'secondary' ? `1px solid ${GRAY_DARK}` : '1.5px solid #302628')};
  background: ${({ $variant }) => ($variant === 'secondary' ? WHITE : '#302628')};
  color: ${({ $variant }) => ($variant === 'secondary' ? GRAY_DARK : '#FFFFFF')};
  &:hover {
    opacity: 0.9;
    ${({ $variant }) =>
      $variant === 'primary' &&
      `
      background-color: ${WHITE};
      color: ${BLACK};
      border-color: ${BLACK};
    `}
  }
`

export const CornerIcon = styled(Icon)`
  top: 8px;
  right: 8px;
  font-size: 24px;
  background-color: #E8E5E5;
  padding: 6px;
  border-radius: 4px;
  color: black;
  transform: scaleX(-1);
  position: absolute;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/Review/styledComponents.tsx